import React,{ useState, useEffect } from 'react';

function TVTroubleshooting() {

    return (
        <div id="modem-setup-component" className="modem-setup-component modem-connectivity-component">
            <h2>Start TV Troubleshooting Tips</h2>
            <h4>Ways to Optimize Your Start TV Experience</h4>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Out of Home</div>
            <p style={{ fontSize:'0.9rem' }}>Ensure your Set Top Box is connected to YOUR home network. If you are not at home – this error code is valid.</p>
            <ul style={{ marginTop:0, marginBottom:0 }}>
                <li>Log out then Force Stop. Re-open Start TV App. Sign back in</li>
            </ul>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Black Screen on Start TV</div>
            <ul style={{ marginTop:0, marginBottom:0 }}>
                <li>Force Stop Start TV App then open Start TV</li>
            </ul>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Too Many Streams</div>
            <p style={{ fontSize:'0.9rem' }}>The maximum number of devices using one Start TV login at a given time is four.</p>
            <ul style={{ marginTop:0, marginBottom:0 }}>
                <li>Sign Out of Multiple Devices</li>
            </ul>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>TV Low Bandwidth</div>
            <p style={{ fontSize:'0.9rem' }}>Ensure your devices are connected to the internet. If using Wi-Fi, please ensure you have a strong signal.</p>
            <ul style={{ marginTop:0, marginBottom:0 }}>
                <li>If you are connected via Ethernet cable please ensure the cable is secured on both ends</li>
                <li>If you are connected via Wi-Fi connection run a StartCARE Network Scan, which can help diagnose potential Wi-Fi issues</li>
            </ul>
            <p style={{ fontSize:'0.9rem' }}>For all of the above issues, refer to our Troubleshoot Steps that follow.</p>

            <h4 style={{ marginTop:'3rem' }}>Troubleshooting Start TV Steps</h4>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Force Stop</div>
            <ol style={{ marginTop:0, marginBottom:0 }}>
                <li>Press the Home Button on the Start TV remote control</li>
                <li>Select Settings</li>
                <li>Select Apps</li>
                <li>Select Start TV</li>
                <li>Select Force Stop, then select OK</li>
                <li>Once the app has been force stopped, Open Start TV app</li>
                <li>Pick your favourite show, sit back and relax</li>
            </ol>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Sign Out Multiple Devices</div>
            <ol style={{ marginTop:0, marginBottom:0 }}>
                <li>Press the Start TV Button on the remote</li>
                <li>Press Settings</li>
                <li>Select Device Settings</li>
                <li>Select My Devices</li>
                <li>Select Sign Out of All Other Devices. Then select Sign Out of All Other Devices again</li>
                <li>Power cycle the Set Top Box, open Start TV App and sign back in as required</li>
                <li>Pick your show, you’re good to go!</li>
            </ol>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Log Out</div>
            <ol style={{ marginTop:0, marginBottom:0 }}>
                <li>Press the Start TV button on your remote to get to the Start TV landing page</li>
                <li>Navigate to the gear icon at the top to get to settings</li>
                <li>Select Account Settings</li>
                <li>Select Sign Out</li>
                <li>You will be prompted to sign back in</li>
                <li>You're ready!</li>
            </ol>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>TV Remote Not Responding</div>
            <ol style={{ marginTop:0, marginBottom:0 }}>
                <li>Change the batteries then retest</li>
                <li>If you’ve recently changed the batteries or they are new, try reseating the batteries then retest</li>
                <li>If the remote is still not responding, try power cycling the Set-Top Box for 1 minute. To do so, unplug the power cord from the Set Top Box for 1 minute then reconnect the power cord. Once the Set Top Box loads back up – test the remote</li>
                <li>If the remote is still not responding please contact our Support Team at <a href="tel:1-866-668-0001" >1-866-668-0001</a> – we’ll get you up and running</li>
            </ol>
        </div>
    )
}

export default TVTroubleshooting